module.exports = __webpack_public_path__ + "img/组 7417@2x.8364a827.png";